// copied from Typescript v5.8, remove after upgrading TS
// https://github.com/microsoft/TypeScript/blob/11e79327598db412a161616849041487673fadab/src/lib/es2024.promise.d.ts#L1
declare global {
    interface PromiseWithResolvers<T> {
        promise: Promise<T>;
        resolve: (value: T | PromiseLike<T>) => void;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        reject: (reason?: any) => void;
    }

    interface PromiseConstructor {
        /**
         * Creates a new Promise and returns it in an object, along with its resolve and reject functions.
         * @returns An object with the properties `promise`, `resolve`, and `reject`.
         *
         * ```ts
         * const { promise, resolve, reject } = Promise.withResolvers<T>();
         * ```
         */
        withResolvers<T>(): PromiseWithResolvers<T>;
    }
}

Promise.withResolvers =
    Promise.withResolvers ||
    (Promise.withResolvers = function <T>() {
        let resolve;
        let reject;
        const promise = new this((res, rej) => {
            resolve = res;
            reject = rej;
        });
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return { resolve: resolve!, reject: reject!, promise } as PromiseWithResolvers<T>;
    });

export {};
